/**
 * Uniform response that the hook 'useApiClient' returns for all api calls.
 */
export class ApiClientResponse {
	/** True indicates the api call was aborted by the caller */
	isAborted = false;

	/** True indicates the api call had an error */
	isError = false;

	/** True indicates the API server responded with the multi-status value (207) instead of 200, 202 etc. */
	isMultiStatus = false;

	/** The response data from the API */
	data = null;

	/** number indicating the HTTP response status code such as 200, 404 - refer to HTTP StatusCodes */
	status = null;

	/** ApiError object containing details of any error */
	error = null;

	/** String of the standard ETag value */
	eTag = null;

	/** Object containing properties of various header values - refer to RESPONSE_HEADER_KEYS */
	headers = null;

	constructor({
		isAborted = false,
		isError = false,
		isMultiStatus = false,
		data = null,
		status = null,
		error = null,
		eTag = null,
		headers = null,
	} = {}) {
		this.isAborted = isAborted;
		this.isError = isError;
		this.isMultiStatus = isMultiStatus;
		this.data = data;
		this.status = status;
		this.error = error;
		this.eTag = eTag;
		this.headers = headers;
	}
}
